import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof fbq === "function") {
      fbq("track", "Purchase", {
        value: 1599,
        currency: "INR",
      });
    } else {
      console.warn("Facebook Pixel is not loaded");
    }
  }, []);

  return (
    <div
      style={{
        fontFamily: "Poppins, sans-serif",
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <header></header>

      <main
        style={{
          backgroundColor: "#ffffff",
          marginTop: "30px",
          padding: "30px 20px",
          borderRadius: "12px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          maxWidth: "500px",
          width: "100%",
        }}
      >
        <div
          style={{
            fontSize: "48px",
            color: "green",
            marginBottom: "20px",
          }}
        >
          ✔️
        </div>

        <h1
          style={{
            margin: "10px 0",
            color: "#d53877",
            fontSize: "28px",
            fontWeight: 600,
          }}
        >
          Thank You !
        </h1>

        <p style={{ fontSize: "18px", color: "#333" }}>
          Your booking and payment were successful.
        </p>
        <p style={{ fontSize: "16px", color: "#555" }}>
          We’ll contact you shortly with your appointment details.
        </p>
        <br></br>
        <button
          onClick={() => navigate("/")}
          style={{
            backgroundColor: "#4e5cf1",
            color: "#fff",
            border: "none",
            padding: "10px 24px",
            borderRadius: "25px",
            fontSize: "16px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          ← Home
        </button>
      </main>
    </div>
  );
};

export default ThankYou;
